module.exports = __webpack_public_path__ + "static/media/portfolio-4.98a23c9f.jpg";